module.exports = __webpack_public_path__ + "toGroom-jp-r-n.b3d1ec2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-r-n.jpg
// module id = 4OD9
// module chunks = 0